import React from "react";

const About = ({ data }) => {
  const {
    paragraph = '',
    md_quote = '',
    md_msg = [],
    md_name = '',
    md_title = '',
    md_email = '',
  } = data || {};

  return (
    <div id="about">
    <div className="container">
      <div className="row">

        <div className="col-xs-12 col-md-12">
          <div className="about-text">
              <h2>About Us</h2>
              <p style={{ textAlign: 'justify'}}>{paragraph}</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <img src="/img/main/img1.webp" className="img-responsive same-size" alt="" loading="lazy" />
          </div>
          <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <img src="/img/main/img2.webp" className="img-responsive same-size" alt="" loading="lazy" />
          </div>
          <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <img src="/img/main/img3.webp" className="img-responsive same-size" alt="" loading="lazy" />
          </div>
          <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <img src="/img/main/img4.webp" className="img-responsive same-size" alt="" loading="lazy" />
          </div>
        </div>


        <div className="row" style={{ marginTop: '30px' , textAlign:"center"}}>
          <div className="col-xs-12 col-md-12">
            <div className="about-text" style={{ textAlign:"justify"}}>
              <h3>From the MD's desk</h3>
              <div className="row">
                <div className="col-sm-12 col-md-3 col-lg-3">
                  <img src="/img/intro/md.png" className="img-responsive" alt={md_name} loading="lazy" />
                  <p style={{marginTop:'5px', marginBottom:'1px', paddingBottom:'0px'}}>{md_quote}</p>

                </div>
                <div className="col-xs-12 col-md-9 col-lg-9" style={{paddingLeft:'30px'}}>
                {md_msg.map((text, index) => (
                  <p key={index} style={{ textAlign: 'justify', marginTop: index ? '10px' : '2px', marginBottom:'0px'}}>{text}</p>
                ))}
                <div style={{float:'right', marginTop:'15px' , marginBottom:'0px'}}>
                  <h3 style={{ textAlign:"justify"}}><b>{md_name}</b></h3>
                  <span style={{ textAlign:"justify"}}><b>({md_title})</b></span>
                  <br/>
                  <span style={{ textAlign:"justify"}}><b>Email: {md_email}</b></span>
                </div>


                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
